import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/routeKeys";
import axios from "axios";
import { BASE_URL } from "../../utils/Element";
import { completeRegex } from "../../utils/utils";
import ProgressBar from "../../components/ProgressBar";
import OnboardLayout from "../../layouts/OnboardLayout";
import { NotificationManager } from "react-notifications";
import PasswordInput from "../../components/PasswordInput";
import usePasswordValidation from "../../hooks/usePasswordValidation";

const NewPassword = () => {
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState("");
  const email = localStorage.getItem("email");
  const [disable, setDisable] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [progress, handleProgress] = usePasswordValidation();

  useEffect(() => {
    handleProgress(newPassword);
  }, [newPassword]);

  const handleChangePassword = (e) => {
    e.preventDefault();
    setErrMsg("");
    const dataToSend = {
      email: email,
      password: newPassword,
      password_confirmation: confirmPassword,
    };

    if (newPassword?.match(completeRegex)) {
      setDisable(true);
      axios
        .post(`${BASE_URL}/change-password`, dataToSend)
        .then((res) => {
          setErrMsg("");
          setPasswordErr(false);
          navigate(ROUTES.PASSWORD_SUCCESS);
          if (res?.data?.message) {
            NotificationManager.success(res?.data?.message);
          }
        })
        .catch((err) => {
          setErrMsg(err?.response?.data?.errors);
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => {
          setDisable(false);
        });
    } else {
      setPasswordErr(true);
    }
  };

  const handleSetPassword = (e) => {
    setNewPassword(e.target.value);
  };

  return (
    <OnboardLayout title={"New Password"} desc={"Enter a new password for your account."}>
      <form className=" login-form" onSubmit={handleChangePassword}>
        {errMsg !== "" && <p className="error">{errMsg}</p>}
        <div className="mb-4 mt-[18px]">
          <label className="dark-H head-4 mb-2" htmlFor="newPassword">
            New Password
          </label>
          <PasswordInput name="newPassword" value={newPassword} onChange={handleSetPassword} />
        </div>

        <div className="mb-4">
          <label className="dark-H head-4 mb-2" htmlFor="username">
            Again Password
          </label>
          <PasswordInput name="againPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
        </div>

        <ProgressBar width={progress} />

        <p className={`body-S mt-4 ${passwordErr ? "red-D" : "dark-M"}`}>Password must be 8+ characters with at least one uppercase, one lowercase, one number, and one special character.</p>
        <button type="submit" disabled={disable} className="green-bg-H body-L light-L py-[8px] px-[18px] login-button" onClick={handleChangePassword}>
          Change Password
        </button>

        <p className="body-N dark-M mt-6">
          Click here to access the{" "}
          <span className="head-5 green-H underline" role="button" onClick={() => navigate(ROUTES.LOGIN)}>
            Login Page
          </span>
        </p>
      </form>
    </OnboardLayout>
  );
};

export default NewPassword;
